import React, { Component } from "react";
import ShopListItem from '../shop_list_item/shop_list_item';
import Flexbox from 'flexbox-react';
import ShopListRow2Items from './shop_list_row_2_items';
import ShopListRow1ItemWide from './shop_list_row_1_item_wide';
import {observer} from 'mobx-react';

const shopListItemWrapper = {
	"width": "100%",
	"height": "100%",
    "fontSize": "2.45em",
	"color": "rgba(0, 0, 0, 0.87)"
};

const componentWidths = {
    image: "24.5%",
    body: "58%",
    status: "19%"
};



@observer
export default class ShopListRow extends Component {
    render() {
        let row = '';
        if (this.props.shop1 && this.props.shop2) {
            row = <ShopListRow2Items shop1={this.props.shop1} shop2={this.props.shop2}/>
        } else if (this.props.wide) {
            row = <ShopListRow1ItemWide shop={this.props.shop1}/>
        } else {
            row = <Flexbox style={shopListItemWrapper}><ShopListItem componentWidths={componentWidths} shop={this.props.shop1}/></Flexbox>
        }
        return (
            <Flexbox height="100%" width="100%">
                {row}
            </Flexbox>

        );
    }

}


// WEBPACK FOOTER //
// ./src/components/shop_list/shop_list_row.jsx